import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Login } from '../model/master/login/login';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  objLogin = new Login();
  loginFailed = false;

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
  }

  submit() {
    if (
      this.objLogin &&
      this.objLogin.UserName &&
      this.objLogin.UserPassword
    ) {
      this.auth
        .login(this.objLogin.UserName, this.objLogin.UserPassword)
        .subscribe(
          data => {
            if (data && data.IsSuccess === true) {
              this.router.navigate(['/', 'index']);
            } else {
              this.loginFailed = true;
            }
          },
          error => {
            this.loginFailed = true;
            console.log(error);
          }
        );
    } else {
      this.loginFailed = true;
    }
  }

  navigate() {
    this.router.navigate(['/', 'forgot_password']);
  }


}
